<template>
  <header class="navbar-background">
    <nav class="navbar navbar-expand-md py-0 mx-auto" style="max-width: 1280px; height: 100px;">
      <div class="hstack company-info">
        <div>
          <a class="navbar-brand mx-2 mx-md-4" href="/">
            <img src="../assets/images/el-icon.svg" />
          </a>
        </div>
        <div class="vstack pt-3 text-center">
          <div class="fs-4">良元科技有限公司</div>
          <div class="fs-6" style="color: #10638F;">EL Tech Solutions</div>
        </div>
      </div>

      <button class="navbar-toggler collapsed me-2 ms-auto" type="button" ref="navbarToggler" data-bs-toggle="collapse" data-bs-target="#navbarNav"
        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse justify-content-end" id="navbarNav" ref="navbarNav">
        <ul class="navbar-nav ms-auto">
          <!--關於我們-->
          <li class="nav-item nav-item-ex">
            <a class="nav-link vstack" href="#" @click="handleChangeTab('intro')" :class="{ active: tab === 'intro' }">
              <div class="nav-icon-wrapper mb-2">
                <img src="../assets/images/nav/about-us.svg" class="nav-icon">
              </div>
              <div class="descrpt-text">{{ $t('nav-about-us') }}</div>
            </a>
          </li>
          <!--作品/專案-->
          <li class="nav-item nav-item-ex">
            <a class="nav-link vstack" href="#" @click="handleChangeTab('projects')" :class="{ active: tab === 'projects' }">
              <div class="nav-icon-wrapper mb-2">
                <img src="../assets/images/nav/portfolio.svg" class="nav-icon">
              </div>
              <div class="descrpt-text">{{ $t('nav-portfolio') }}</div>
            </a>
          </li>
          <!--聯絡我們-->
          <li class="nav-item nav-item-ex">
            <a class="nav-link vstack" href="#" @click="handleChangeTab('contact')" :class="{ active: tab === 'contact' }">
              <div class="nav-icon-wrapper mb-2">
                <img src="../assets/images/nav/contact-us.svg" class="nav-icon">
              </div>
              <div class="descrpt-text">{{ $t('nav-contact-us') }}</div>
            </a>
          </li>
          <!--Q & A-->
          <li class="nav-item nav-item-ex">
            <a class="nav-link vstack" href="#" @click="handleChangeTab('qa')" :class="{ active: tab === 'qa' }">
              <div class="nav-icon-wrapper mb-2">
                <img src="../assets/images/nav/q-and-a.svg" class="nav-icon">
              </div>
              <div class="descrpt-text">{{ $t('nav-q-and-a') }}</div>
            </a>
          </li>

          <!-- 語言切換按鈕 -->
          <!-- <li class="nav-item nav-item-ex">
            <a class="nav-link vstack" href="#" @click="handleChangeLang(lang === 'en' ? 'zh-tw' : 'en')">
              <div class="nav-icon-wrapper mb-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-translate" viewBox="0 0 16 16">
                  <path d="M4.545 6.714 4.11 8H3l1.862-5h1.284L8 8H6.833l-.435-1.286zm1.634-.736L5.5 3.956h-.049l-.679 2.022z" />
                  <path
                    d="M0 2a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v3h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-3H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zm7.138 9.995q.289.451.63.846c-.748.575-1.673 1.001-2.768 1.292.178.217.451.635.555.867 1.125-.359 2.08-.844 2.886-1.494.777.665 1.739 1.165 2.93 1.472.133-.254.414-.673.629-.89-1.125-.253-2.057-.694-2.82-1.284.681-.747 1.222-1.651 1.621-2.757H14V8h-3v1.047h.765c-.318.844-.74 1.546-1.272 2.13a6 6 0 0 1-.415-.492 2 2 0 0 1-.94.31" />
                </svg>
              </div>
              <div class="descrpt-text">{{ lang === 'en' ? '中文' : 'English' }}</div>
            </a>
          </li> -->

        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  mounted() {
    // console.log(this.tab)
    // console.log(this.lang)
    if (!this.tab) {
      this.handleChangeQuery(this.tab || 'intro', this.lang || 'zh-tw');
    }
  },
  methods: {
    handleChangeQuery(toTab, toLang) {
      this.$refs.navbarNav.classList.remove('show');
      this.$refs.navbarToggler.setAttribute('aria-expanded', 'false');
      this.$refs.navbarToggler.classList.add('collapsed');
      this.$router.replace({ path: `/`, query: { tab: toTab, lang: toLang } });
    },
    handleChangeTab(toTab) {
      this.handleChangeQuery(toTab || 'intro', this.lang || 'zh-tw');
    },
    handleChangeLang(toLang) {
      const newQuery = { ...this.$route.query, tab: this.tab || 'intro', lang: toLang };
      const newUrl = `${window.location.pathname}?${new URLSearchParams(newQuery).toString()}`;
      window.location.href = newUrl; // 這將重新加載頁面
    },
  },
  computed: {
    tab() {
      // console.log(this.$route.query.tab);
      return this.$route.query.tab;
    },
    lang() {
      // console.log(this.$route.query.lang);
      return this.$route.query.lang;
    }
  }
}
</script>

<style>
.navbar-background {
  background-color: #eee;
  position: relative;
  z-index: 1000;
  height: 100px;
}

.company-info {
  position: absolute;
  top: 20px;
  left: 0;
  z-index: 1001;
  /* background-color: #aaa; */
}

.descrpt-text {
  font-weight: 500;
  text-align: center;
  color: black;
}

.nav-link {
  display: flex;
  justify-content: center;
  align-items: center;
}

.nav-link:hover .descrpt-text {
  font-weight: 800;
  color: lightslategray;
}

.nav-link:hover .nav-icon-wrapper {
  box-shadow: 6px 6px 8px rgba(0, 0, 0, 0.45);
}

.nav-link.active .descrpt-text {
  font-weight: 800;
  color: lightslategray;
}

.nav-link.active .nav-icon-wrapper {
  box-shadow: 6px 6px 8px rgba(0, 0, 0, 0.45);
}

.nav-icon-wrapper {
  background-color: white;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  box-shadow: 4px 4px 6px rgba(0, 0, 0, 0.1);
}

.nav-item-ex {
  width: 100px;
}

@media (max-width: 767.98px) {
  .navbar {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .company-info {
    padding: 0px 0;
  }

  .navbar-container {
    position: relative;
  }

  .navbar-collapse {
    position: absolute;
    top: 100%;
    right: 0;
    left: 0;
    padding: 0.5rem;
    z-index: 1000;
  }

  .navbar-nav {
    flex-direction: column;
    width: 80px;
  }

  .nav-item {
    padding: 0.5rem 0;
  }

  .nav-icon-wrapper {
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    box-shadow: 4px 4px 6px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.3s ease;
  }
}
</style>